import { motion } from "framer-motion";
import { Truck, Zap, ShieldCheck, MapPin } from "lucide-react";

const ITEMS = [
  { icon: Truck, label: "Trasporti Nazionali" },
  { icon: Zap, label: "Puntualità" },
  { icon: ShieldCheck, label: "Sicurezza Totale" },
  { icon: MapPin, label: "Copertura Italia" },
  { icon: Truck, label: "Logistica Integrata" },
  { icon: Zap, label: "Preventivi Rapidi" },
  { icon: ShieldCheck, label: "Cura della Merce" },
  { icon: MapPin, label: "Assistenza 24/7" },
];

export default function Marquee() {
  const loop = [...ITEMS, ...ITEMS];
  return (
    <section
      data-testid="marquee-section"
      aria-hidden="true"
      className="relative py-10 md:py-14 bg-[#050505] border-y border-white/5 overflow-hidden"
    >
      <div className="absolute inset-y-0 left-0 w-32 z-10 bg-gradient-to-r from-[#050505] to-transparent pointer-events-none" />
      <div className="absolute inset-y-0 right-0 w-32 z-10 bg-gradient-to-l from-[#050505] to-transparent pointer-events-none" />

      <motion.div
        className="flex whitespace-nowrap gap-14"
        animate={{ x: ["0%", "-50%"] }}
        transition={{ duration: 42, ease: "linear", repeat: Infinity }}
      >
        {loop.map((it, i) => (
          <div
            key={i}
            className="inline-flex items-center gap-4 shrink-0"
          >
            <span className="font-heading text-4xl md:text-6xl font-black uppercase tracking-[-0.02em] steel-text-gradient">
              {it.label}
            </span>
            <it.icon size={28} className="text-blue-400 shrink-0" />
            <span className="h-2 w-2 rounded-full bg-blue-500 shrink-0" />
          </div>
        ))}
      </motion.div>
    </section>
  );
}
